import { QueryClient } from '@tanstack/react-query';

/**
 * The single QueryClient shared by every federated entry in this remote.
 *
 * Each fed export is mounted independently by the host (there is no common React
 * ancestor to provide a client), and @tanstack/react-query is NOT shared with the host
 * via Module Federation — the host is on v4 and this remote on v5, which cannot share a
 * singleton. So every fed wrapper imports THIS module-level instance instead of creating
 * its own `new QueryClient()`. That guarantees one cache across the whole remote: an edit
 * in one fed export (e.g. MeetingPageDocument) is immediately visible to a read-only view
 * in another (e.g. MeetingPages). Creating a client per fed file split the cache and made
 * the read-only view render stale data after an edit.
 */
export const fedQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
    mutations: {
      retry: 1,
    },
  },
});
